import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppLoadingService } from './features/auth/services/app-loading.service';
import { LoadingComponent } from './shared/components/loading-component/loading.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'arbeidsgiver';
  private loading = inject(AppLoadingService);
  loading$ = this.loading.loading$;

}
